import type { vendorApiNames } from '../names';
import type { UsernamePasswordAuthentication } from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

export interface NsxTServerSettings {
  /**
   * When the NSX-T client adapts his rate limitation settings to the server settings, it’s necessary to calculate `refillRate`.
   * The `serverRateLimiterSettingsRefillRateFactorPct` sets a number of percent of the adapted `maxCapacity`.
   */
  serverRateLimiterSettingsRefillRateFactorPct?: number;
  /**
   * The NSX-T client retrieves rate limitation settings from the server. When the retrieved rate limitation settings are below the configured rate limitation settings,
   * the client adapts his setting to the received settings. The `serverSettingsSafetyFactor` sets a number of percent of the received rate limitation settings to be applied.
   */
  serverRateLimiterSettingsSafetyFactorPct?: number;
}

/**
 * NSX-T API settings available from API
 */
export type PublicNsxTApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['nsxT']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings &
  NsxTServerSettings;

/**
 * NSX-T API settings available in backend
 */
export type NsxTApiSettings = PublicNsxTApiSettings &
  UsernamePasswordAuthentication;

/**
 * NSX-T API settings expected on API when updating
 */
export type UpdateNsxTApiSettings = BaseUpdateVendorApiSettings<
  PublicNsxTApiSettings,
  UsernamePasswordAuthentication
>;
